import { Link } from 'react-router-dom';
import { articles, getCategoryBySlug, hotArticles } from '@/mocks/articles';

const formatViews = (views: number) => `${(views / 10000).toFixed(1)} 万`;

export default function HomeHero() {
  const lead = articles.find((a) => a.featured) ?? articles[0];
  const side = articles.filter((a) => a.featured && a.id !== lead.id).slice(0, 1)[0] ?? articles[1];
  const leadCategory = getCategoryBySlug(lead.category);

  return (
    <section aria-label="首屏精选" className="mx-auto w-full max-w-[1280px] px-4 pt-6 md:px-6 md:pt-8">
      <div className="grid grid-cols-1 gap-5 lg:grid-cols-3">
        <article className="relative col-span-1 overflow-hidden rounded-lg lg:col-span-2">
          <div className="h-[320px] w-full md:h-[420px]">
            <img
              src={lead.cover}
              alt={lead.title}
              title={`${lead.title} - 看料99 首发爆料`}
              className="h-full w-full object-cover object-top"
            />
          </div>
          <div className="absolute inset-0 flex flex-col justify-end bg-gradient-to-t from-black/75 via-black/35 to-transparent p-5 md:p-8">
            <div className="flex flex-wrap items-center gap-2">
              <span className="inline-flex items-center gap-1 rounded-full bg-primary-500 px-3 py-1 text-xs font-medium text-background-50 dark:text-foreground-950">
                <i className="ri-flashlight-fill" aria-hidden="true"></i>
                独家首发
              </span>
              <span className="rounded-full bg-background-50/20 px-3 py-1 text-xs text-background-50 backdrop-blur">
                {leadCategory?.name}
              </span>
            </div>
            <h1 className="mt-3 font-heading text-2xl font-bold leading-tight text-white md:text-4xl">
              {lead.title}
            </h1>
            <p className="mt-3 hidden max-w-2xl text-sm leading-relaxed text-background-100 md:block">
              {lead.summary}
            </p>
            <div className="mt-4 flex flex-wrap items-center gap-4">
              <Link
                to={`/article/${lead.id}`}
                className="inline-flex items-center gap-1.5 rounded-md bg-primary-500 px-4 py-2.5 text-sm font-medium text-background-50 dark:text-foreground-950 whitespace-nowrap transition-colors hover:bg-primary-600"
              >
                阅读全文
                <i className="ri-arrow-right-line" aria-hidden="true"></i>
              </Link>
              <span className="flex items-center gap-1 text-xs text-background-200">
                <i className="ri-eye-line" aria-hidden="true"></i>
                {formatViews(lead.views)} 阅读
              </span>
            </div>
          </div>
        </article>

        <aside className="col-span-1 flex flex-col gap-5">
          <Link
            to={`/article/${side.id}`}
            className="group relative block overflow-hidden rounded-lg"
          >
            <div className="h-[180px] w-full">
              <img
                src={side.cover}
                alt={side.title}
                title={`${side.title} - 看料99`}
                className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
            </div>
            <div className="absolute inset-0 flex flex-col justify-end bg-gradient-to-t from-black/80 to-transparent p-4">
              <span className="text-xs text-accent-300">{getCategoryBySlug(side.category)?.name}</span>
              <h2 className="mt-1 line-clamp-2 font-heading text-base font-semibold text-white">
                {side.title}
              </h2>
            </div>
          </Link>

          <div className="flex-1 rounded-lg border border-background-200 bg-background-100 p-4">
            <div className="flex items-center justify-between">
              <h2 className="flex items-center gap-1.5 font-heading text-base font-semibold text-foreground-950">
                <i className="ri-fire-fill text-primary-500" aria-hidden="true"></i>
                今日热榜
              </h2>
              <Link to="/category" className="text-xs text-foreground-500 transition-colors hover:text-primary-600">
                全部
              </Link>
            </div>
            <ol className="mt-3 space-y-1">
              {hotArticles.slice(0, 5).map((item, index) => (
                <li key={item.id}>
                  <Link
                    to={`/article/${item.id}`}
                    className="group flex items-start gap-3 rounded-md p-1.5 transition-colors hover:bg-background-50"
                  >
                    <span
                      className={`mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded text-xs font-bold ${
                        index < 3
                          ? 'bg-primary-500 text-background-50 dark:text-foreground-950'
                          : 'bg-background-300 text-foreground-700'
                      }`}
                    >
                      {index + 1}
                    </span>
                    <span className="line-clamp-2 text-sm leading-snug text-foreground-800 transition-colors group-hover:text-primary-600">
                      {item.title}
                    </span>
                  </Link>
                </li>
              ))}
            </ol>
          </div>
        </aside>
      </div>
    </section>
  );
}